import { jsx as l } from "react/jsx-runtime";
const r = (v) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...v,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M44.65 30.305a6.693 6.693 0 1 0 0-13.385 6.693 6.693 0 0 0 0 13.385Zm0-11.326a4.639 4.639 0 0 1 4.633 4.634 4.639 4.639 0 0 1-4.633 4.633 4.639 4.639 0 0 1-4.634-4.633 4.639 4.639 0 0 1 4.634-4.634ZM46.904 41.632v2.06h9.624l-.552-2.06h-9.072ZM44.65 31.078l-9.17 2.43 4.02 1.065 5.15-1.365 11.326 3.002v5.422l2.06-.552v-6.454L44.65 31.078ZM25.404 31.314c5.597 0 10.15-4.553 10.15-10.15S31 11.014 25.404 11.014c-5.597 0-10.15 4.553-10.15 10.15 0 5.596 4.553 10.15 10.15 10.15Zm0-16.331a6.188 6.188 0 0 1 6.18 6.18 6.188 6.188 0 0 1-6.18 6.182 6.188 6.188 0 0 1-6.181-6.181 6.188 6.188 0 0 1 6.18-6.181ZM5.603 37.844v10.478a3.478 3.478 0 0 0 3.47 3.478h33.051l-.905-3.38 3.985-1.067v-9.509l-19.8-5.248-19.8 5.248Zm35.632 10.572H9.573v-7.517l15.83-4.197L41.236 40.9v7.517Z"
      }
    )
  }
);
export {
  r as Seats
};
